import { render, staticRenderFns } from "./draggableDynamicTableRow.vue?vue&type=template&id=163863d8"
import script from "./draggableDynamicTableRow.vue?vue&type=script&lang=js"
export * from "./draggableDynamicTableRow.vue?vue&type=script&lang=js"
import style0 from "./draggableDynamicTableRow.vue?vue&type=style&index=0&id=163863d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports